var _defs, _style, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmericanexpress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 77",
    width: 84,
    height: 77,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 84,
    height: 77,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABNBAMAAADKnF6hAAAAAXNSR0IB2cksfwAAAA9QTFRF////w93pTZq8EXimiLvS5pc48AAAAeFJREFUeJzt1kFvmzAUAODnwBVwyI4tMHMOo7BrItT87U1iWo8Dm/sgsO4KGLJjCDPppCmESp2mSZWGhTHIn6znZxuB4MUFzfS1UB0/b075BV1Zz9OOzXSmM72k6xD1YKe/XoMQaRwAc/kItjKijZHd7w8VySxo1cXNIpZxRr4S4+FGGtE3tVX6dbyrExO4xXUtMRuzjv1T4hxGFPt9ZvPU3xebcOGw9xo1mM07AuyKwu7TWodsVRUu7K1G1Zny3aW3+rKvxhR5NV5ScmyLLWs8tR6o06iIuacxlV28h4oo3wqDN+cAiFZYFVCvG1NpwyRcrlIyBGDgH1rk86xfabGtXMUqO/HvpAchiCzLazo047zK22YJp0X+tGiiOeWkr3XoEdR/uweWovaFeOT4qRXDV/oxnKCRqAuVTw9+SekdQNqKm3IAFN+B8ohLCU8GQE2OzJY7iYn2HjVzyUrF1fMpSqyIILp5WA+U4MjGH338YTIAl1d++uhCuYKeudyQeCk2zWQARi47kGxZ7cU7sbfEJB02rMTkqOhWgi5511K9t3irIqNA41NwpkkAXSgFX+zy7WfMA4j8Ltx1dGpaQ153XQh+mYtDde7X+PmUXdHp8uo+GTP97+kf/JK9oMz039Cf37wpXQcbL8gAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanexpress);
export default __webpack_public_path__ + "static/media/americanexpress.d4d3a24c64f1d8df3bf76f5cb57b64dc.svg";
export { ForwardRef as ReactComponent };